import { render, staticRenderFns } from "./BannerContent.vue?vue&type=template&id=d6c60e04&"
import script from "./BannerContent.vue?vue&type=script&lang=js&"
export * from "./BannerContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports